import Handlebars from 'handlebars';

const clonedEscapeExpression = Handlebars.Utils.escapeExpression;

Handlebars.Utils.escapeExpression = function (string) {
  return clonedEscapeExpression(string).replace(/&#x3D;/g, '=');
};

export default Handlebars;



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/handle-url.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/handle-url.js